import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'p-inputSwitch',
  standalone: false,
  templateUrl: './input-switch.html',
  styleUrl: './input-switch.sass',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSwitch),
      multi: true
    }
  ]
})
export class InputSwitch implements ControlValueAccessor {
  @Input('trueValue') trueValue?: string;
  @Input('falseValue') falseValue?: string;

  _value: any;

  writeValue(value: any): void {
    this._value = value;
  }

  propagateChange = (_: any) => {

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    
  }

  setDisabledState?(isDisabled: boolean): void {
    
  }

  _onValueChange(event: any){
    this._value = event;
    this.propagateChange(event);
  }
}
